import React from "react";
import CustomCard from "../../../shared/Card/CustomCard";
import EmployeeForm from "./EmployeeForm";

export default function EditEmployee({ name }) {
  return (
    <CustomCard title={name} backable>
      <EmployeeForm type="EDIT" />
    </CustomCard>
  );
}
